/* eslint-disable-next-line */
import { useLocation } from '@reach/router';

import {
  AccountCircle as AccountCircleIcon,
  Search as SearchIcon,
  ShoppingCart as ShoppingCartIcon,
  ShoppingCartOutlined as ShoppingCartOutlinedIcon,
} from '@material-ui/icons';
import {
  AppBar,
  Avatar,
  Badge,
  Button,
  Grid,
  Hidden,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { HiMenuAlt3 } from 'react-icons/hi';
import { RiCloseCircleFill } from 'react-icons/ri';
import { Link, navigate } from 'gatsby';
import { scroller } from 'react-scroll';
import * as React from 'react';

import { StoreContext } from '../context/store-context';
import { getUser, isLoggedIn, logout } from '../utils/auth';
import MotionDrawer from './shared/motion-drawer';
import logo from '../images/logo.svg';
import useAppbarStyles from '../styles/app-bar';

export default function Header() {
  const classes = useAppbarStyles();
  const location = useLocation();
  const user = getUser();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { checkout } = React.useContext(StoreContext);
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const items = checkout ? checkout.lineItems : [];

  const quantity = items.reduce((total, item) => total + item.quantity, 0);

  const handleMenu = (event) => setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  // const signOut = () => {
  //   handleClose();
  //   logout(firebase);
  //   navigate('/account/login');
  // };

  const navigateAndScroll = (path, element) => {
    if (location.pathname !== path) {
      navigate(path);
    }

    setTimeout(
      () =>
        scroller.scrollTo(element, {
          smooth: 'easeInOut',
        }),
      100,
    );
  };

  const handleToggleDrawer = () => setOpenDrawer(!openDrawer);

  return (
    <>
      <MotionDrawer open={openDrawer} onClose={handleToggleDrawer} />

      <div className={classes.root}>
        <Menu
          id="menu-logout"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
        >
          {isLoggedIn() ? (
            <MenuItem
              onClick={() => {
                handleClose();
                navigate('/account/me');
              }}
            >
              Perfil
            </MenuItem>
          ) : (
            <MenuItem
              onClick={() => {
                handleClose();
                navigate('/account/login');
              }}
            >
              Iniciar sesión
            </MenuItem>
          )}

          {isLoggedIn() ? (
            <MenuItem
              onClick={() => {
                handleClose();
                logout();
                navigate('/');
              }}
            >
              Cerrar sesión
            </MenuItem>
          ) : (
            <MenuItem
              onClick={() => {
                handleClose();
                navigate('/account/signup');
              }}
            >
              Regístrate
            </MenuItem>
          )}
        </Menu>

        <Grid>
          <AppBar color="primary">
            <Toolbar>
              <div className={classes.navigation}>
                <div className={classes.navigationTitle}>
                  <Typography variant="h6">
                    <Link to="/">
                      <img
                        alt="Motor-X Logo"
                        className={classes.logo}
                        src={logo}
                      />
                    </Link>
                  </Typography>
                </div>
                <Button
                  variant="text"
                  onClick={() => navigate('/search')}
                  className={classes.navigationLink}
                  component="div"
                >
                  <Typography
                    className={
                      location.pathname === '/search' ? classes.active : null
                    }
                    variant="subtitle1"
                  >
                    Tienda
                  </Typography>
                </Button>

                <Hidden smUp>
                  <IconButton
                    color="secondary"
                    aria-label="menu"
                    onClick={handleToggleDrawer}
                  >
                    {openDrawer ? (
                      <RiCloseCircleFill className={classes.menuIcon} />
                    ) : (
                      <HiMenuAlt3 className={classes.menuIcon} />
                    )}
                  </IconButton>
                </Hidden>

                <Hidden smDown>
                  <Button
                    variant="text"
                    onClick={() => navigateAndScroll('/', 'index-services')}
                    className={classes.navigationLink}
                    component="div"
                  >
                    <Typography variant="subtitle1">Servicios</Typography>
                  </Button>

                  <Button
                    variant="text"
                    onClick={() => navigate('/')}
                    className={classes.navigationLink}
                    component="div"
                  >
                    <Typography variant="subtitle1">Historia</Typography>
                  </Button>

                  <Button
                    variant="text"
                    onClick={() => navigateAndScroll('/', 'index-contact')}
                    className={classes.navigationLink}
                    component="div"
                  >
                    <Typography variant="subtitle1">Contacto</Typography>
                  </Button>
                </Hidden>
              </div>

              <Hidden smDown>
                <div className={classes.iconContainer}>
                  <IconButton
                    className={classes.iconButton}
                    disableRipple
                    disableFocusRipple
                    aria-label="buscar"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    color="inherit"
                    onClick={() => navigate('/search#more')}
                  >
                    <SearchIcon />
                  </IconButton>
                </div>

                <div className={classes.iconContainer}>
                  <IconButton
                    className={classes.iconButton}
                    disableRipple
                    disableFocusRipple
                    aria-label="buscar"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    color="inherit"
                    onClick={handleMenu}
                  >
                    {isLoggedIn ? (
                      <Avatar
                        className={classes.avatar}
                        alt={user?.displayName}
                        src={user?.photoURL}
                      >
                        {user?.photoURL}
                      </Avatar>
                    ) : (
                      <AccountCircleIcon />
                    )}
                  </IconButton>
                </div>

                <div className={classes.iconContainer}>
                  <IconButton
                    disableRipple
                    disableFocusRipple
                    onClick={() => navigate('/cart')}
                    aria-label={`${quantity} artículos en el carrito de compras`}
                    color="inherit"
                  >
                    {quantity > 0 ? (
                      <Badge badgeContent={quantity} color="secondary">
                        <ShoppingCartIcon />
                      </Badge>
                    ) : (
                      <ShoppingCartOutlinedIcon />
                    )}
                  </IconButton>
                </div>
              </Hidden>
            </Toolbar>
          </AppBar>
        </Grid>
      </div>
    </>
  );
}
